import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card';
import {
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableHeader,
  TableRow,
} from '@/components/ui/table';
import { Badge } from '@/components/ui/badge';
import { CurrentPrice } from '../interfaces/mock.interface';
import { DollarSign, Calendar } from 'lucide-react';
import { format } from 'date-fns';
import { ro } from 'date-fns/locale';

interface CurrentPricesWidgetProps {
  prices: CurrentPrice[];
  maxRows?: number;
}

export const CurrentPricesWidget = ({ prices, maxRows = 10 }: CurrentPricesWidgetProps) => {
  const getCurrencySymbol = (currency: string) => {
    const symbols: Record<string, string> = {
      USD: '$',
      EUR: '€',
      RON: 'lei',
    };
    return symbols[currency] || currency;
  };

  if (prices.length === 0) {
    return (
      <Card className="w-full h-full flex flex-col">
        <CardHeader>
          <CardTitle className="flex items-center gap-2">
            <DollarSign className="h-5 w-5" />
            Prețuri Actuale (Navlu)
          </CardTitle>
        </CardHeader>
        <CardContent>
          <p className="text-sm text-muted-foreground text-center py-8">
            Nu există oferte valabile cu prețuri active.
          </p>
        </CardContent>
      </Card>
    );
  }

  // Limit prices to maxRows
  const limitedPrices = prices.slice(0, maxRows);

  return (
    <Card className="w-full h-full flex flex-col">
      <CardHeader className="flex-shrink-0">
        <CardTitle className="flex items-center gap-2">
          <DollarSign className="h-5 w-5" />
          Prețuri Actuale (Navlu)
        </CardTitle>
        <p className="text-sm text-muted-foreground">
          Oferte valabile în prezent
        </p>
      </CardHeader>
      <CardContent className="flex-1 flex flex-col">
        <div className="rounded-md border flex-1 overflow-auto">
          <Table>
            <TableHeader>
              <TableRow>
                <TableHead>Tip</TableHead>
                <TableHead className="text-right">Preț</TableHead>
                <TableHead>Valabilitate</TableHead>
              </TableRow>
            </TableHeader>
            <TableBody>
              {limitedPrices.map((price, index) => (
                <TableRow key={index}>
                  <TableCell>
                    <Badge variant="secondary" className="text-xs">
                      {price.containerType}
                    </Badge>
                  </TableCell>
                  <TableCell className="text-right">
                    <div className="flex items-baseline justify-end gap-1">
                      <span className="text-lg font-bold">
                        {price.price.toLocaleString()}
                      </span>
                      <span className="text-sm text-muted-foreground">
                        {getCurrencySymbol(price.currency)}
                      </span>
                    </div>
                  </TableCell>
                  <TableCell>
                    <div className="flex items-center gap-1 text-xs text-muted-foreground">
                      <Calendar className="h-3 w-3" />
                      {format(new Date(price.validTo), 'dd MMM yyyy', {
                        locale: ro,
                      })}
                    </div>
                  </TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </div>
      </CardContent>
    </Card>
  );
};
